


























































import { defineComponent } from "@vue/composition-api";
import Avatar from '@/components/Avatar.vue'
import { useUserStore } from '@/pinia/modules/user'
import { storeToRefs } from 'pinia'
export default defineComponent({
  components: {
    Avatar,
  },
  setup(props, { root }) {
    const userStore = useUserStore()
    const { userInfo } = storeToRefs(userStore)
    return {
      userStore,
      userInfo,
    }
  }
});
